var _circle, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIAtm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 55 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27.5,
    cy: 27,
    r: 27,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.8263 22.0426H29.0763V17.6092C29.0763 17.2942 28.7963 17.1426 28.6096 17.1426C28.5513 17.1426 28.493 17.1542 28.4346 17.1776L19.183 20.6659C18.5646 20.8992 18.168 21.4826 18.168 22.1476V22.9292C17.1063 23.7226 16.418 24.9942 16.418 26.4292V22.1476C16.418 20.7592 17.2696 19.5226 18.5646 19.0326L27.828 15.5326C28.0846 15.4392 28.353 15.3926 28.6096 15.3926C29.7763 15.3926 30.8263 16.3376 30.8263 17.6092V22.0426Z",
    fill: "#4034AB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5835 31.083C38.5835 31.398 38.3385 31.6547 38.0118 31.6663H36.3085C35.6901 31.6663 35.1301 31.2113 35.0835 30.6047C35.0485 30.243 35.1885 29.9047 35.4218 29.6713C35.6318 29.4497 35.9235 29.333 36.2385 29.333H38.0001C38.3385 29.3447 38.5835 29.6013 38.5835 29.9163V31.083Z",
    fill: "#4034AB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.418 28.1087C38.0596 28.1087 38.5846 27.5837 38.5846 26.942V26.4287C38.5846 24.0137 36.613 22.042 34.198 22.042H20.8046C19.813 22.042 18.903 22.3687 18.168 22.9287C17.1063 23.722 16.418 24.9937 16.418 26.4287V34.2803C16.418 36.6953 18.3896 38.667 20.8046 38.667H34.198C36.613 38.667 38.5846 36.6953 38.5846 34.2803V34.0587C38.5846 33.417 38.0596 32.892 37.418 32.892H36.403C35.283 32.892 34.2096 32.2037 33.918 31.1187C33.673 30.232 33.9646 29.3803 34.548 28.8087C34.9796 28.3653 35.5746 28.1087 36.228 28.1087H37.418ZM21.668 27.8753C21.1896 27.8753 20.793 27.4787 20.793 27.0003C20.793 26.522 21.1896 26.1253 21.668 26.1253H29.8346C30.313 26.1253 30.7096 26.522 30.7096 27.0003C30.7096 27.4787 30.313 27.8753 29.8346 27.8753H21.668Z",
    fill: "#4034AB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIAtm);
export default __webpack_public_path__ + "static/media/iAtm.1f4f2a2ebbc27b5a9bb815c836e3845d.svg";
export { ForwardRef as ReactComponent };